import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { logError } from "../logging";
import { localeKeyToFullLanguageName } from "./localeKeyToFullLanguageName";
/**
 * Given a list of ILocaleKey, returns true if a duplicate language exists in the list.
 * @param locales list of ILocaleKey to check for duplicate language
 * @returns true if there are one or more duplicate languages in the list
 */
export var hasDuplicateLanguages = function hasDuplicateLanguages(locales) {
  var languagesSeen = {};
  var _iterator = _createForOfIteratorHelper(locales),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var localeKey = _step.value;
      if (localeKey.language) {
        if (localeKey.language in languagesSeen) {
          return true;
        } else {
          // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
          languagesSeen[localeKey.language] = 1;
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
};
/**
 * Returns true if the language occurs more than once in the list of locales
 * @param language the language to check for duplicates
 * @param locales the array of locales to check in
 * @returns true if the language occurs more than once
 */
export var isLanguageDuplicatedInLocales = function isLanguageDuplicatedInLocales(language, locales) {
  var timesSeen = 0;
  var _iterator2 = _createForOfIteratorHelper(locales),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var localeKey = _step2.value;
      if (localeKey.language === language && timesSeen > 0) {
        return true;
      }
      if (localeKey.language === language) {
        timesSeen += 1;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return false;
};
var markDuplicateLocaleKeyLanguage = function markDuplicateLocaleKeyLanguage(availableLocales) {
  var languagesSeen = {};
  var _iterator3 = _createForOfIteratorHelper(availableLocales),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var localeKey = _step3.value;
      if (localeKey.language) {
        if (localeKey.language in languagesSeen) {
          // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
          languagesSeen[localeKey.language] += 1;
        } else {
          // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
          languagesSeen[localeKey.language] = 1;
        }
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return availableLocales.filter(function (localeKey) {
    return !!localeKey.language;
  }).map(function (localeKey) {
    // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
    if (languagesSeen[localeKey.language] > 1) {
      return _objectSpread(_objectSpread({}, localeKey), {}, {
        duplicate: true
      });
    }
    return localeKey;
  });
};
/**
 * Returns ILocaleOption list for avaiilable locales. Shows full locale for duplicate languages.
 * E.g. "English (US) - EN-US" and "English (UK) - EN-GB".
 * @param availableLocales list of locale keys
 * @returns list of ILocaleOption with string label and value
 */
export var languageOptionsWithDisambiguatedLocale = function languageOptionsWithDisambiguatedLocale(availableLocales) {
  var availableLocalesWithDuplicatesMarked = markDuplicateLocaleKeyLanguage(availableLocales);
  return availableLocalesWithDuplicatesMarked.map(function (localeKey) {
    if (localeKey.language === undefined) {
      logError(new Error("Cannot create language option from undefined language."));
      return {
        label: "Unknown Language",
        value: {
          language: Language.LANGUAGE_UNKNOWN,
          country: undefined
        }
      };
    }
    return {
      label: "".concat(localeKeyToFullLanguageName(localeKey, !!localeKey.duplicate)),
      value: localeKey
    };
  });
};